import * as cnt from './constants';
export const loadHelpSideBarPages = () => { return { type: cnt.SIDEBARHELP_INIT }; };



// WEBPACK FOOTER //
// ./src/app/components/sidebarHelp/actions.js